export default "__VITE_ASSET__7ec37012__"